/**
 * Slider principal — Optimizado
 * ------------------------------------------------------------
 * - Usa setTimeout recursivo en lugar de setInterval.
 * - Pausa cuando la pestaña no está visible (ahorra CPU).
 * - Configuración dinámica desde data-attributes.
 */
(function() {
  'use strict';

  function initSlidersPrincipales() {
    const sliders = document.querySelectorAll('[data-slider-principal]');

    sliders.forEach(slider => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';

      const slides = Array.from(slider.querySelectorAll('.slider-principal__slide'));
      const dots   = Array.from(slider.querySelectorAll('.slider-principal__dot'));

      if (slides.length === 0) return;

      const autoplayEnabled = slider.dataset.autoplayEnabled === 'true';
      const autoplaySpeed   = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;

      let currentIndex = 0;
      let timeoutId    = null;
      let isPaused     = false;

      function goToSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });

        currentIndex = index;
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function scheduleNext() {
        if (!autoplayEnabled || isPaused) return;
        timeoutId = setTimeout(() => {
          nextSlide();
          scheduleNext();
        }, autoplaySpeed);
      }

      function startAutoplay() {
        if (timeoutId) return;
        scheduleNext();
      }

      function stopAutoplay() {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
      }

      // --- Event Listeners ---

      slider.addEventListener('mouseenter', () => { isPaused = true; });
      slider.addEventListener('mouseleave', () => { isPaused = false; });

      // Pausa al cambiar de pestaña para ahorrar CPU
      document.addEventListener('visibilitychange', () => {
        isPaused = document.hidden;
      });

      // Navegación por dots
      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const slideIndex = parseInt(dot.dataset.slideTo, 10);
          if (!isNaN(slideIndex)) {
            goToSlide(slideIndex);
            stopAutoplay();
            startAutoplay();
          }
        });
      });

      // --- Init ---
      goToSlide(0);
      startAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlidersPrincipales);
  } else {
    initSlidersPrincipales();
  }

  // Re-inicializa al editar en el editor de temas
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('[data-slider-principal]')) {
        initSlidersPrincipales();
      }
    });
  }
})();